
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 154 200"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Layer_3"}},[_c('path',{attrs:{"fill":"#5b89c1","d":"M119 3.1L113.8 0 45.7 39.3l.5 157.5 5.3 3.2z"}}),_c('path',{attrs:{"fill":"#73a6f9","d":"M119 3.1l34 19.3.2 118.8L51.5 200l-.6-157.6z"}}),_c('path',{attrs:{"fill":"#8dc5fa","d":"M119 3.1l34 19.3-33.8 19.5z"}}),_c('path',{staticClass:"st3",attrs:{"d":"M86.5 89.8c-3.5 2-6.4 6.9-6.3 11 0 4 2.9 5.7 6.4 3.6 3.5-2 6.4-7 6.3-11-.1-4-2.9-5.6-6.4-3.6m18.2 22.9c-11 6.4-20.6 18.7-25.9 31.9l7.8.9c3.7-9.2 10.4-17.9 18.1-22.3 7.7-4.5 14.5-3.6 18.2 1.3l7.8-9.9c-5.3-7.1-15-8.3-26-1.9m18.1-43.8c-3.5 2-6.4 6.9-6.3 11 0 4 2.9 5.7 6.4 3.6 3.5-2 6.4-7 6.3-11s-2.9-5.7-6.4-3.6"}})]),_c('g',{attrs:{"id":"Layer_1"}},[_c('path',{attrs:{"d":"M9.9 96.4c1.2.9 8.6 4.6 8.6 4.6L72 5.4l-6-3c-7-3.8-16.6-3.1-27.1 3C17.4 17.7 0 47.7 0 72.4c0 11.4 3.7 19.6 9.9 24z","fill":"#be3c2a"}}),_c('ellipse',{attrs:{"transform":"rotate(-59.689 45.33 53.216)","cx":"45.3","cy":"53.2","rx":"54.8","ry":"31.6","fill":"#e54c3c"}}),_c('path',{staticClass:"st6",attrs:{"d":"M30.2 54.7L27 52.8l7.1-12.7 3.3 1.9zM30.3 79l-3.2-1.8 28.6-49.6 3.2 1.9z"}}),_c('path',{staticClass:"st3",attrs:{"d":"M58.9 29.5l7.5 4-10.8 18.8 10.7 6.2L59 71.1 48.1 65 37.5 83.4 30.3 79l10.4-18.2-10.5-6.1L37.4 42l10.7 5.9z"}})])])
          )
        }
      }
    